import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as customerActions from "../../redux/actions/customers";
import { Modal } from "../../components/layout/Modal";
import { Button, Loading } from "../../components/widgets";
import { accessTokenItemName } from "../../redux/actions/user";
import CustomerContractsUploadChangesDetails from "../../components/customers/CustomerContractsUploadChangesDetails";
import CustomerContractsAppliedChangesDetails from "../../components/customers/CustomerContractsAppliedChangesDetails";
import "./CustomerContractsUpload.css";

const mapStateToProps = state => ({
  customers: state.customers,
});

const mapDispatchToProps = dispatch => {
  return {
    customerActions: bindActionCreators(customerActions, dispatch),
  };
};

const PROGRESS_STATUS_MAP = {
  FETCHING_SIGNED_URL: {
    type: "inprogress",
    step: 1,
    message: "Establishing connection",
  },
  UPLOAD_IN_PROGRESS: {
    type: "inprogress",
    step: 2,
    message: "Uploading file",
  },
  UPLOAD_COMPLETE: {
    type: "inprogress",
    step: 3,
    message: "Upload complete - waiting to process file",
  },
  UPLOAD_FAILURE: {
    type: "error",
    step: 4,
    message: "Upload failure",
  },
  CSV_CONVERSION_IN_PROGRESS: {
    type: "inprogress",
    step: 5,
    message: "Processing file",
  },
  CSV_CONVERSION_SUCCESS: {
    type: "inprogress",
    step: 6,
    message: "File successfully processed",
  },
  CSV_DATA_RECEIVED: {
    type: "inprogress",
    step: 7,
    message: "Waiting to process changes",
  },
  CHANGE_SET_PROCESSING_IN_PROGRESS: {
    type: "inprogress",
    step: 8,
    message: "Processing changes",
  },
  CHANGE_SET_PROCESSING_COMPLETE: {
    type: "complete",
    message: "",
  },
  CSV_CONVERSION_FAILURE: {
    type: "error",
    message: "File processing failure",
  },
  APPLY_CUSTOMER_CHANGES_ERROR: {
    type: "error",
    message: "Error applying changes",
  },
  APPLY_CUSTOMER_CHANGES_PROGRESS: {
    type: "inprogress",
    message: "Applying changes",
  },
  CHANGES_APPLIED: {
    type: "applied",
    message: "",
  },
};

const TOTAL_IN_PROGRESS_STEPS = 9;

const FileName = ({ file }) => (
  <div className="select-filename">
    {file ? (
      <span>
        <i className="fa fa-file-o" />
        {file.name}
      </span>
    ) : null}
  </div>
);

class CustomerContractsUploadFileSelection extends Component {
  render() {
    return (
      <span className="upload-file-container">
        <div className="drag-icon">
          <svg
            height="100%"
            id="svg2"
            width="100%"
            version="1.1"
            viewBox="0 0 70 46"
            style={{
              fill:
                (this.props.isDraggingFile || this.props.selectedFile) && !this.props.dragMessage
                  ? "#4698CB"
                  : "#E7EDF7",
            }}
          >
            <path d="M55.1,16.1C63.3,16.2,70,22.9,70,31.1C70,39.3,63.2,46,54.9,46c-0.4,0-0.9-0.1-1.3-0.1C53.2,46,52.8,46,52.4,46H37.3V31.7 l2.9,3c0.9,0.9,2.3,0.9,3.2,0c0.9-0.9,0.9-2.3,0-3.2l-6.8-6.7c-0.3-0.3-0.7-0.5-1.1-0.6H35h-0.5c-0.4,0.1-0.8,0.3-1.1,0.6l-6.8,6.7 c-0.9,0.9-0.9,2.3,0,3.2c0.9,0.9,2.3,0.9,3.2,0l2.9-3l0,14.2H11C5,45.9,0,41.1,0,35c0-5.6,4.4-10.4,10-10.9 c-0.1-0.4-0.1-0.8-0.1-1.2C9.9,10.3,20.2,0,33,0C43.4,0,52.1,6.8,55.1,16.1L55.1,16.1z" />
          </svg>
        </div>
        <div className="drag-title">Drag your file here to import</div>
        <div className="upload-input-controls">
          or{" "}
          <button onClick={this.props.selectFile} className="choose-file">
            choose your file
          </button>
          <input
            className="hidden"
            type="file"
            ref={this.props.registerUploadInput}
            onChange={this.props.handleUploadInputOnChange}
            accept=".csv, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
        <div className="upload-buttons">
          <FileName file={this.props.selectedFile} />
        </div>
      </span>
    );
  }
}

const ChangeSummaryItem = ({ title, count, className, onClick }) => (
  <li className={"change-summary-row " + className} onClick={onClick}>
    <span className={"title" + (onClick ? " link" : "")}>{title}</span>
    <span className="count">{count}</span>
  </li>
);

class CustomerContractsUploadChangesSummary extends Component {
  applyCustomerContractChanges = () => {
    this.setState({
      processing: true,
    });
    this.props.applyCustomerContractChanges(this.props.filename);
  };

  render() {
    let changeSet = this.props.changeSet;
    let setDetailView = this.props.setDetailView;

    if (!changeSet) {
      return null;
    }

    return (
      <div className="changes-summary-container">
        <h2>File Summary</h2>
        <ul className="rows-container">
          {changeSet.added.length > 0 ? (
            <ChangeSummaryItem
              title="New Customers"
              count={changeSet.added.length}
              onClick={() => setDetailView("added")}
            />
          ) : null}
          {changeSet.changed.length > 0 ? (
            <ChangeSummaryItem
              title="Updates"
              count={changeSet.changed.length}
              onClick={() => setDetailView("changed")}
            />
          ) : null}
          {changeSet.removed.length > 0 ? (
            <ChangeSummaryItem
              title="Removed Customers"
              count={changeSet.removed.length}
              onClick={() => setDetailView("removed")}
            />
          ) : null}
          {changeSet.nochange.length > 0 ? (
            <ChangeSummaryItem
              title="Unchanged"
              count={changeSet.nochange.length}
              onClick={() => setDetailView("nochange")}
            />
          ) : null}
          {changeSet.unknown.length > 0 ? (
            <ChangeSummaryItem
              title="Unknown"
              count={changeSet.unknown.length}
              onClick={() => setDetailView("unknown")}
            />
          ) : null}
          {changeSet.error.length > 0 ? (
            <ChangeSummaryItem
              title="Error"
              count={changeSet.error.length}
              onClick={() => setDetailView("error")}
            />
          ) : null}
          <ChangeSummaryItem
            title="Total"
            count={
              changeSet.added.length +
              changeSet.changed.length +
              changeSet.removed.length +
              changeSet.nochange.length +
              changeSet.unknown.length +
              changeSet.error.length
            }
            className="total"
          />
        </ul>
      </div>
    );
  }
}

class CustomerContractsAppliedChangesSummary extends Component {
  render() {
    const rpToken = localStorage.getItem(accessTokenItemName);
    let changeSet = this.props.changeSet;
    let setDetailView = this.props.setDetailView;

    return (
      <div className="changes-summary-container">
        <h2>File Summary</h2>
        <ul className="rows-container">
          {changeSet.success.length > 0 ? (
            <ChangeSummaryItem
              title="Successfully changed"
              count={changeSet.success.length}
              onClick={() => setDetailView("success")}
            />
          ) : null}
          {changeSet.partial.length > 0 ? (
            <ChangeSummaryItem
              title="Partially successful"
              count={changeSet.partial.length}
              onClick={() => setDetailView("partial")}
            />
          ) : null}
          {changeSet.failed.length > 0 ? (
            <ChangeSummaryItem
              title="Unsuccessful"
              count={changeSet.failed.length}
              onClick={() => setDetailView("failed")}
            />
          ) : null}
          {changeSet.nochange.length > 0 ? (
            <ChangeSummaryItem
              title="Unchanged"
              count={changeSet.nochange.length}
              onClick={() => setDetailView("nochange")}
            />
          ) : null}
          {changeSet.unknown.length > 0 ? (
            <ChangeSummaryItem
              title="Unknown"
              count={changeSet.unknown.length}
              onClick={() => setDetailView("unknown")}
            />
          ) : null}
          <ChangeSummaryItem
            title="Total"
            count={
              changeSet.success.length +
              changeSet.failed.length +
              changeSet.partial.length +
              changeSet.nochange.length +
              changeSet.unknown.length
            }
            className="total"
          />
        </ul>
        <div className="download-template-container">
          <a
            href={
              process.env.REACT_APP_MARKETPLACE_API_URL +
              "/contracts/response?auth=Bearer " +
              rpToken +
              "&filename=" +
              this.props.filename
            }
          >
            Download response CSV
          </a>
        </div>
      </div>
    );
  }
}

class CustomerContractsUploadChanges extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailView: null,
    };
  }

  componentWillReceiveProps = nextProps => {
    if (
      this.props.uploadStatus !== nextProps.uploadStatus &&
      nextProps.uploadStatus === "CSV_DATA_RECEIVED"
    ) {
      nextProps.processChangeSet(nextProps.filename);
    } else if (
      this.props.uploadStatus !== nextProps.uploadStatus &&
      nextProps.uploadStatus === "CHANGE_SET_PROCESSING_COMPLETE"
    ) {
      nextProps.fetchCustomerContractsUploadChanges(nextProps.filename);
    }
  };

  setDetailView = view => {
    this.setState({
      detailView: view,
    });
  };

  clearDetailView = () => {
    this.setState({
      detailView: null,
    });
  };

  render() {
    if (this.props.uploadStatus === "CHANGES_APPLIED") {
      if (this.state.detailView) {
        const changes = this.props.changeSet[this.state.detailView];
        return (
          <CustomerContractsAppliedChangesDetails
            backToSummary={this.clearDetailView}
            changesList={changes}
            changeType={this.state.detailView}
          />
        );
      } else {
        return (
          <CustomerContractsAppliedChangesSummary
            selectedFile={this.props.selectedFile}
            filename={this.props.filename}
            changeSet={this.props.changeSet}
            setDetailView={this.setDetailView}
            applyCustomerContractChanges={this.props.applyCustomerContractChanges}
          />
        );
      }
    }

    if (
      this.props.uploadStatus !== "UPLOAD_FAILURE" &&
      this.props.uploadStatus !== "APPLY_CUSTOMER_CHANGES_ERROR"
    ) {
      if (this.props.uploadStatus !== "CHANGE_SET_PROCESSING_COMPLETE" || !this.props.changeSet) {
        return (
          <div className="loading-spinner-container">
            <Loading />
          </div>
        );
      }
    } else {
      return null;
    }

    if (this.state.detailView) {
      const changes = this.props.changeSet[this.state.detailView];
      return (
        <CustomerContractsUploadChangesDetails
          backToSummary={this.clearDetailView}
          changesList={changes}
          changeType={this.state.detailView}
        />
      );
    } else {
      return (
        <CustomerContractsUploadChangesSummary
          selectedFile={this.props.selectedFile}
          filename={this.props.filename}
          changeSet={this.props.changeSet}
          setDetailView={this.setDetailView}
          applyCustomerContractChanges={this.props.applyCustomerContractChanges}
        />
      );
    }
  }
}

class CustomerContractsUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFilename: null,
      isDraggingFile: false,
      dragMessage: null,
    };
  }

  componentWillReceiveProps = nextProps => {
    const thisStatus = this.props.customers.customerContractsUpload
      ? this.props.customers.customerContractsUpload.status
      : null;
    const nextStatus = nextProps.customers.customerContractsUpload
      ? nextProps.customers.customerContractsUpload.status
      : null;

    if (thisStatus !== nextStatus) {
      if (nextStatus === "UPLOAD_COMPLETE") {
        this.registerStatusUpdateInterval();
      } else if (
        nextStatus === "CHANGE_SET_PROCESSING_COMPLETE" ||
        nextStatus === "CSV_CONVERSION_FAILURE"
      ) {
        this.clearStatusUpdateInterval();
      }
    }
  };

  componentWillUnmount = () => {
    this.clearStatusUpdateInterval();
    this.props.customerActions.clearCustomerContractsUpload();
  };

  clearStatusUpdateInterval = () => {
    if (this.statusUpdateInterval) {
      clearInterval(this.statusUpdateInterval);
    }
  };

  registerStatusUpdateInterval = () => {
    this.clearStatusUpdateInterval();
    this.statusUpdateInterval = setInterval(() => {
      this.props.customerActions.fetchCustomerContractsUploadProgress(
        this.props.customers.customerContractsUpload.filename
      );
    }, 2000);
  };

  registerUploadInput = uploadInput => {
    this.uploadInput = uploadInput;
  };

  handleUploadInputOnChange = e => {
    if (this.uploadInput.files.length > 0) {
      this.setState({
        selectedFile: this.uploadInput.files[0],
      });
    }
  };

  selectFile = e => {
    e.preventDefault();
    this.uploadInput.click();
  };

  getDragFileMessage = dataTransfer => {
    let dragMessage = null;
    if (dataTransfer.items.length > 1) {
      dragMessage = "Only one file can be imported at a time";
    }

    const item = dataTransfer.items[0];
    if (item.kind !== "file") {
      dragMessage = "Only files may be imported";
    }

    if (item.type !== "text/csv") {
      dragMessage = "Only CSV files may be imported";
    }

    return dragMessage;
  };

  handleFileDragOver = e => {
    // Without preventing default here the onDrop event never fires in Chrome.
    e.preventDefault();
    const dt = e.dataTransfer;

    const dragMessage = this.getDragFileMessage(dt);

    if (!this.state.isDraggingFile) {
      this.setState({
        isDraggingFile: true,
        dragMessage: dragMessage,
      });
    }
  };

  handleFileDragLeave = e => {
    e.preventDefault();
    if (this.state.isDraggingFile) {
      this.setState({
        isDraggingFile: false,
        dragMessage: null,
      });
    }
  };

  handleFileOnDrop = e => {
    e.preventDefault();
    const dt = e.dataTransfer;

    const dragMessage = this.getDragFileMessage(dt);

    if (dt.items.length === 1 && dragMessage === null) {
      const item = dt.items[0];
      // If its not a file just ignore it.
      if (item.kind === "file") {
        this.setState({
          selectedFile: dt.items[0].getAsFile(),
        });
      }
    }

    this.handleFileDragLeave(e);
  };

  uploadCustomerContracts = () => {
    this.props.customerActions.uploadCustomerContracts(this.state.selectedFile);
  };

  completeUpload = () => {
    this.props.customerActions.clearCustomersContracts();
    this.props.customerActions.fetchCustomersContracts();
    this.props.handleOnCancel();
  };

  render() {
    let uploadStatus;
    if (this.props.customers.customerContractsUpload) {
      const status = this.props.customers.customerContractsUpload.status;
      uploadStatus = PROGRESS_STATUS_MAP[status];
    }

    const rpToken = localStorage.getItem(accessTokenItemName);

    if (this.props.customers.customerContractsUpload === null) {
      return (
        <Modal className="customer-contracts-upload-modal">
          <Modal.Header title="Customer Upload" />
          <Modal.Content>
            {this.state.dragMessage ? (
              <div className="customer-contract-upload-file-error">
                <p>{this.state.dragMessage}</p>
              </div>
            ) : null}
            <div className="customer-contract-upload-container">
              <div
                className="upload-drop-zone"
                onDragOver={this.handleFileDragOver}
                onDragLeave={this.handleFileDragLeave}
                onDrop={this.handleFileOnDrop}
              >
                <CustomerContractsUploadFileSelection
                  isDraggingFile={this.state.isDraggingFile}
                  dragMessage={this.state.dragMessage}
                  selectFile={this.selectFile}
                  selectedFile={this.state.selectedFile}
                  registerUploadInput={this.registerUploadInput}
                  handleUploadInputOnChange={this.handleUploadInputOnChange}
                />
                {!this.props.customers.customerContractsUpload ? (
                  <div className="download-template-container">
                    First time uploading data?{" "}
                    <a
                      href={
                        process.env.REACT_APP_MARKETPLACE_API_URL +
                        "/contracts/template?auth=Bearer " +
                        rpToken
                      }
                    >
                      Download our CSV template
                    </a>
                  </div>
                ) : null}
              </div>
            </div>
          </Modal.Content>
          <Modal.Footer>
            <Button
              id="customers-upload-cancel"
              type="secondary"
              onClick={this.props.handleOnCancel}
              icon="times"
            >
              Cancel
            </Button>
            {this.state.selectedFile ? (
              <Button
                id="customer-upload-begin-import"
                type="primary"
                onClick={this.uploadCustomerContracts}
                icon="cloud-upload"
              >
                Begin Import
              </Button>
            ) : null}
          </Modal.Footer>
        </Modal>
      );
    } else if (
      this.props.customers.customerContractsUpload &&
      this.props.customers.customerContractsUpload.status === "CSV_CONVERSION_FAILURE"
    ) {
      return (
        <Modal className="customer-contracts-upload-modal">
          <Modal.Header title="Customer Contracts Upload" />
          <Modal.Content>
            <div className="customer-contract-upload-container">
              <div className="upload-status error">
                <span className="message">{uploadStatus.message}</span>
              </div>
            </div>
          </Modal.Content>
          <Modal.Footer>
            <Button
              id="customer-upload-csv-conversion-failure-close"
              type="primary"
              onClick={this.props.handleOnCancel}
              icon="times"
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      );
    } else {
      return (
        <Modal className="customer-contracts-upload-modal">
          <Modal.Header title={this.state.selectedFile.name} />
          <Modal.Content>
            <div className="customer-contract-upload-container">
              <CustomerContractsUploadChanges
                selectedFile={this.state.selectedFile}
                uploadStatus={this.props.customers.customerContractsUpload.status}
                fetchCustomerContractsUploadChanges={
                  this.props.customerActions.fetchCustomerContractsUploadChanges
                }
                processChangeSet={this.props.customerActions.processChangeSet}
                filename={this.props.customers.customerContractsUpload.filename}
                changeSet={this.props.customers.customerContractsUpload.changeSet}
                applyCustomerContractChanges={
                  this.props.customerActions.applyCustomerContractChanges
                }
              />
              {uploadStatus ? (
                uploadStatus.type === "error" ? (
                  <div className={"upload-status " + uploadStatus.type}>{uploadStatus.message}</div>
                ) : (
                  <div className={"upload-status " + uploadStatus.type}>
                    {uploadStatus.step ? (
                      <span>
                        ({uploadStatus.step}/{TOTAL_IN_PROGRESS_STEPS})
                      </span>
                    ) : null}
                    <br />
                    <span className="message">{uploadStatus.message}</span>
                  </div>
                )
              ) : null}
            </div>
          </Modal.Content>
          <Modal.Footer>
            {uploadStatus.type === "error" ? (
              <Button
                id="customers-upload-close-from-failure"
                type="primary"
                icon="times"
                onClick={this.props.handleOnCancel}
              >
                Close
              </Button>
            ) : null}
            {uploadStatus.type === "complete" ? (
              <>
                <Button
                  id="customer-upload-apply-changes-canel"
                  type="secondary"
                  onClick={this.props.handleOnCancel}
                  icon="times"
                >
                  Cancel
                </Button>
                <Button
                  id="customer-upload-apply-changes"
                  type="primary"
                  onClick={() =>
                    this.props.customerActions.applyCustomerContractChanges(
                      this.props.customers.customerContractsUpload.filename
                    )
                  }
                  icon="check"
                >
                  Apply Changes
                </Button>
              </>
            ) : null}
            {uploadStatus.type === "applied" ? (
              <Button
                id="customer-upload-complete-ok"
                type="primary"
                icon="check"
                onClick={this.completeUpload}
              >
                OK
              </Button>
            ) : null}
          </Modal.Footer>
        </Modal>
      );
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerContractsUpload);
